import {action, computed, observable, runInAction} from "mobx";
import {Order} from "../models/order";
import {PendingApprovalsStore} from "./store-pending-approvals";
import {Root} from "./store-root";
import {API} from 'aws-amplify';
import {Summary} from "../models/summary";
import {ExportReportRequest} from "../../features/export/orders-export-container";

export class OrderStore {
    parent: Root;
    PendingApprovalOrders: PendingApprovalsStore;
    @observable Orders: Order[] = [];
    @observable MyOrders: Order[] = [];
    @observable ReadyOrders: Order[] = [];
    @observable Order: Order | undefined = undefined;
    @observable Summary: Summary | undefined = undefined;
    @observable CurrentOrder: Order | undefined = undefined;

    constructor(root: Root) {
        this.parent = root;
        this.PendingApprovalOrders = new PendingApprovalsStore(this);
    }

    @action SetCurrentOrder = (order: Order) => {
        this.CurrentOrder = order;
    }

    @action PlaceOrder = async (order: Order) => {
        order.Status = '0';
        await API.post('backend', '/orders', {'body': order});
        await this.LoadAllOrders();
    }

    @action PayOrder = async (order: Order) => {
        await API.put('backend', '/orders/pay', {'body': order});
        await this.LoadAllOrders();
    }

    @action UpdateOrder = async (order: Order) => {
        await API.put('backend', `/orders/${order.Reference}`, {'body': order})
        await this.LoadAllOrders();
    }

    @action SetOrderAsInProgress = async (order: Order) => {
        await API.put('backend', '/orders/inprogress', {'body': order});
        await this.LoadAllOrders();
    }


    @action LoadAllOrders = async () => {
        const fromBackend = await API.get('backend', '/orders', {});
        this.Orders = [];
        runInAction(() => {
            this.Orders = fromBackend
        })
    }

    @action LoadMyOrders = async (userId: string) => {
        const fromBackend = await API.get('backend', `/orders/agents/${userId}`, {})
        runInAction(() => {
            this.MyOrders = [];
            this.MyOrders = fromBackend;
        })
    }

    @action LoadReadyOrders = async () => {
        const fromBackend = await API.get('backend', '/orders/ready', {});
        runInAction(() => {
            this.ReadyOrders = fromBackend
        })
    }

    searchReadyOrders = (keyword: string): Order[] => {
        if (keyword.length > 0) {
            const filtered: Order[] = this.ReadyOrders.filter((order: Order) => order.Reference.includes(keyword) || order.BeneficiaryPhone.includes(keyword));
            return filtered;
        } else
            return []
    }

    @computed get SupervisorOrders() {
        return this.Orders.filter((item: Order) => (item.Status == '1' || item.Status == '2' || item.Status == '5' || item.Status == '3' || item.Status == '4'))
    }

    @action ApproveOrder = async (order: Order) => {
        await API.put('backend', `/orders/approve`, {'body': order});
        runInAction(() => {
            this.Orders = [];
            this.PendingApprovalOrders.Orders = [];
            this.LoadAllOrders();
            this.PendingApprovalOrders.loadItems();
        })
    }

    @action RejectOrder = async (order: Order) => {
        await API.put('backend', `/orders/reject`, {'body': order});
        runInAction(() => {
            this.Orders = [];
            this.PendingApprovalOrders.Orders = [];
            this.LoadAllOrders();
            this.PendingApprovalOrders.loadItems();
        })
    }

    @action ExportOrders= async (request : ExportReportRequest)=>{
        const response = await API.post('backend','/orders/Export',{'body':request});
        return response;
    }


    @action ExportDailyCashOrders= async ()=>{
        const response = await API.get('backend','/orders/exportdailycash', {});
        return response;
    }

    @action ExportReadyOrders= async (startDate:string, endDate:string)=>{
        const response = await API.get('backend','/orders/exportreadyorders?startDate='+startDate+'&endDate='+endDate, {});
        return response;
    }

    @action ExportDailyBankOrders= async ()=>{
        const response = await API.get('backend','/orders/exportdailybank', {});
        return response;
    }

    @action CancelOrder = async (order: Order) => {
        await API.put('backend', `/orders/cancel`, {'body': order});
        runInAction(() => {
            this.Orders = [];
            this.MyOrders = [];
            this.ReadyOrders = [];
            this.LoadAllOrders();
            this.LoadReadyOrders();
            this.LoadMyOrders(this.parent.Users.UserName);
        })

    }

    @action LoadOrderSummaryForAgent = async (sub: string) => {
        let found: Summary | undefined = undefined;
        console.log('LoadOrderSummaryForAgent - Sub ', sub);
        if (sub) {

            found = await API.get('backend', `/orders/summary/${sub}`, {})
            console.log('LoadOrderSummaryForAgent : Found Object ', found);
            if (found) {
                runInAction(() => {
                    this.Summary = found;
                })
            }
        }
    }

    @action LoadOrderByReference = async (reference: string) => {
        let found: Order | undefined = undefined;
        found = this.Orders.find((item: Order) => item.Reference === reference);
        if (found)
            return found;
        found = await API.get('backend', `/orders/${reference}`, {});
        if (found) {
            runInAction(() => {
                this.Order = found;
                this.Orders.push(found!);
            })
        }
        return found;
    }


}
